import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props, emptyProps } from '@ngrx/store';
import type { NotificationSocketPayloadDto } from '../interfaces/user-notification-socket-payload.interface';

export interface UserNotificationsFilter {
    archived: boolean;
    /**
     * read === true  -> only read
     * read === false -> only unread
     * read === undefined -> no filter on read state
     */
    read?: boolean;
}

export interface UserNotificationsQuery {
    offset: number;
    limit: number;
    filter: UserNotificationsFilter;
}

export type UserNotification = NotificationSocketPayloadDto;

export interface UserNotificationsSlice {
    items: UserNotification[];
    offset: number;
    limit: number;
}

export const userNotificationsActions = createActionGroup({
    source: '[Aumico-Core] User Notifications',
    events: {
        'Load User Notifications': props<{ request: UserNotificationsQuery }>(),
        'Load User Notifications Success': props<{ notifications: UserNotification[]; unreadCount: number; offset: number; limit: number }>(),
        'Load User Notifications Failure': props<{ error: HttpErrorResponse }>(),

        'Set User Notifications Filter': props<{ filter: UserNotificationsFilter }>(),

        'Notification Received': props<{ notification: UserNotification }>(),

        'Connect Notifications Socket': props<{ token: string }>(),
        'Disconnect Notifications Socket': emptyProps(),

        'Update Notification': props<{ notificationIds: string[]; update: {isRead?: boolean; isArchived?: boolean} }>(),
        'Update Notification Success': props<{ notifications: UserNotification[]; unreadCount: number }>(),
        'Update Notification Failure': props<{ error: HttpErrorResponse }>(),
    },
});
